/* istanbul ignore file */

function getNewPath(pathname) {
  if (pathname.startsWith('/campaign/vnext/reports/create/')) {
    return pathname.replace('/campaign/vnext/reports/create/', '/campaign/vnext/reports-v4/create/');
  }
  if (pathname.startsWith('/campaign/vnext/reports/category/')) {
    return '/campaign/vnext/reports-v4/default-reports';
  }
  if (pathname.startsWith('/campaign/vnext/reports/customreports')) {
    return '/campaign/vnext/reports-v4/my-reports/customized';
  }
  if (pathname.startsWith('/campaign/vnext/reports/v2/pollreport/')) {
    return '/campaign/vnext/reports-v4/my-reports/customized';
  }
  if (pathname.startsWith('/campaign/vnext/reports/history')) {
    return '/campaign/vnext/reports-v4/my-reports/customized';
  }
  if (pathname.startsWith('/campaign/vnext/reports/createfromexecuted/')) {
    return '/campaign/vnext/reports-v4/my-reports/customized';
  }
  if (pathname.startsWith('/campaign/vnext/reports/updatetemplate/')) {
    return pathname.replace('/campaign/vnext/reports/updatetemplate/', '/campaign/vnext/reports-v4/edit/');
  }
  if (pathname.startsWith('/campaign/vnext/reports/createfromtemplate/')) {
    return pathname.replace('/campaign/vnext/reports/createfromtemplate/', '/campaign/vnext/reports-v4/edit/');
  }
  return '/campaign/vnext/reports-v4/default-reports';
}

function getNewReportingUIPath(pathname) {
  if (pathname.startsWith('/campaign/vnext/reports/create/')) {
    return pathname.replace('/campaign/vnext/reports/create/', '/campaign/vnext/reports-v4/create/');
  }
  if (pathname.startsWith('/campaign/vnext/reports/category/')) {
    return '/campaign/vnext/reporting/templates';
  }
  if (pathname.startsWith('/campaign/vnext/reports/customreports')) {
    return '/campaign/vnext/reporting/home';
  }
  if (pathname.startsWith('/campaign/vnext/reports/v2/pollreport/')) {
    return '/campaign/vnext/reporting/home';
  }
  if (pathname.startsWith('/campaign/vnext/reports/history')) {
    return '/campaign/vnext/reporting/home';
  }
  if (pathname.startsWith('/campaign/vnext/reports/createfromexecuted/')) {
    return '/campaign/vnext/reporting/home';
  }
  if (pathname.startsWith('/campaign/vnext/reports/updatetemplate/')) {
    return pathname.replace('/campaign/vnext/reports/updatetemplate/', '/campaign/vnext/reports-v4/edit/');
  }
  if (pathname.startsWith('/campaign/vnext/reports/createfromtemplate/')) {
    return pathname.replace('/campaign/vnext/reports/createfromtemplate/', '/campaign/vnext/reports-v4/edit/');
  }
  if (pathname.startsWith('/campaign/vnext/reports-v4/default-reports')) {
    return '/campaign/vnext/reporting/templates';
  }
  if (pathname.startsWith('/campaign/vnext/reports-v4/my-reports/customized')) {
    return '/campaign/vnext/reporting/home';
  }
  return '/campaign/vnext/reporting/home';
}

export function isLegacyReportingUrl(pathname, isNewReportingUI) {
  if (isNewReportingUI) {
    return pathname.startsWith('/campaign/vnext/reports') ||
      pathname.startsWith('/campaign/vnext/reports-v4/default-reports') ||
      pathname.startsWith('/campaign/vnext/reports-v4/my-reports/customized');
  }
  return pathname.startsWith('/campaign/vnext/reports') && !pathname.startsWith('/campaign/vnext/reports-v4');
}

export function redirectReportingUrl(pathname, history, isNewReportingUI) {
  history.replace({
    pathname: isNewReportingUI ? getNewReportingUIPath(pathname) : getNewPath(pathname),
    search: history.location.search,
  });
}
